//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { getWorkShiftIconName } from '../../../components/helpers.js'

import RequestExecutorSelectionWindow from '../RequestExecutorSelectionWindow.vue'
import { requestExecutorActions } from '../RequestExecutorActions.js'
import { requestActionsCancelAssignment } from '../RequestActionsCancelAssignment.js'
import manba from 'manba'

export default {
  components: {
    RequestExecutorSelectionWindow
  },
  mixins: [requestExecutorActions, requestActionsCancelAssignment],
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    label: {
      type: String,
      default: 'ТЕКУЩИЙ ИСПОЛНИТЕЛЬ'
    },
    taskStatus: {
      type: String,
      default () {
        return ''
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      simple: false,
      proposedExecutorsShowInfo: null,
      proposedReinforcementExecutorsShowInfo: null,
      reinforcementExecutorsSelected: [],
      proposedExecutorsAll: null,
      proposedReinforcementExecutorsAll: null,
      proposedExecutorsTime: 0,
      proposedExecutorsUpdateFilterFn: null,
      proposedReinforcementExecutorsUpdateFilterFn: null,
      proposedExecutorsUpdateFilterValue: null,
      roposedReinforcementExecutorsUpdateFilterValue: null,

      showExecutorInput: false,
      showReinforcementExecutorsInput: false,
      ignoreInputChange: false
    }
  },
  computed: {
    isContractorDispatcher: function () {
      const user = this.$store.getters.getUser
      return !user.roles.root && user.hasRole('contractorDispatcher') // user.roles.contractorDispatcher
    },
    executorChangeAvailable: function () {
      return this.requestRoles.executorChangeAvailable
    },
    reinforcementExecutorChangeAvailable: function () {
      return this.requestRoles.reinforcementExecutorChangeAvailable
    },
    removeExecutorAvailable: function () {
      return this.requestRoles.removeExecutorAvailable
    },
    showReinforcementField: function () {
      return this.reinforcementExecutorChangeAvailable &&
        (this.request.proposedExecutorObject ? this.request.proposedExecutorObject.type === 'brigade' : !!this.request.assignedBrigade) ||
        this.request.riAssignedBrigades.length !== 0
    },
    readonlyLocal: function () {
      return this.readonly || !this.executorChangeAvailable
    }
  },
  watch: {
    request: {
      handler: function (request) {
        this.$nextTick(() => {
          this.onUpdateProposedReinforcementExecutorObject(this.request.proposedReinforcementExecutorObject)
          if (this.executorChangeAvailable) {
            this.updateProposedExecutors()
          }
          if (this.reinforcementExecutorChangeAvailable) {
            this.filterExecutor(null, null, null, { force: true, reinforcement: true })
          }
        })
      }
    },
    'request.proposedExecutorObject': {
      handler: 'onProposedExecutorChange',
      immediate: true
    },
    'request.proposedReinforcementExecutorObject': {
      handler: function (object) {
        this.onUpdateProposedReinforcementExecutorObject(object)
      },
      immediate: true
    }
  },
  mounted: function () {
    if (this.executorChangeAvailable) {
      this.updateProposedExecutors()
    }
    if (this.reinforcementExecutorChangeAvailable) {
      this.request.proposedReinforcementExecutorObject = null
      this.filterExecutor(null, null, null, { force: true, reinforcement: true })
    }
  },
  methods: {
    BS2_AnalyzeRequest: function () {
      this.onCancelAssignment(() => {
        this.request.proposedExecutorObject = null
        this.request.proposedReinforcementExecutorObject = null

        this.$emit('task-updated')
      })
    },
    updateProposedExecutors: async function () {
      this.request.proposedExecutorObject = null
      this.request.proposedReinforcementExecutorObject = null
      this.filterExecutor(null, null, null, { force: true })
    },
    onUpdateProposedReinforcementExecutorObject: function (object) {
      if (object == null || object.executors.length === 0) {
        if (object == null && !!this.request.riAssignedBrigades && this.request.riAssignedBrigades.length) {
          this.reinforcementExecutorsSelected = this.request.riAssignedBrigades.map(br => {
            return this.getReinforcementBrigadeObjectOption(this.convertRiAssignedBrigadeFromServer(br))
          })
          this.request.proposedReinforcementExecutorObject = {
            executors: this.request.riAssignedBrigades.map(br => this.convertRiAssignedBrigadeFromServer(br))
          }
        } else {
          this.reinforcementExecutorsSelected = []
        }
      } else {
        this.reinforcementExecutorsSelected = object.executors.map(br => {
          return this.getReinforcementBrigadeObjectOption(br) // return this.convertRiAssignedBrigadeFromServer(br)
        })
        this.request.autoAssign = false
      }
    },
    filterExecutor: async function (val, update, abort, config) {
      const reinforcement = config && config.reinforcement
      if (!reinforcement && this.executorChangeAvailable && this.checkRequestBeforeExecutorsProposal() || reinforcement && this.reinforcementExecutorChangeAvailable && this.checkRequestBeforeExecutorsProposal()) {
        const currentTime = new Date().getTime()
        if ((config && config.force === true) || this.proposedExecutorsTime < currentTime - 30000) { // 30 сек - интервал обновления
          this.proposedExecutorsTime = currentTime
          try {
            // Всегда простой запрос
            this.simple = true
            const proposedBrigades = await this.$refs.executorSelector.getProposedBrigadesSimple(this.request)

            // let proposedBrigades
            // if (this.simple) {
            //   proposedBrigades = await this.$refs.executorSelector.getProposedBrigadesSimple()
            // } else {
            //   try {
            //     proposedBrigades = await this.$refs.executorSelector.getProposedBrigades(null, true)
            //     proposedBrigades = proposedBrigades.filter(brigade => {
            //       return brigade.accessible == null || brigade.accessible
            //     })
            //   } catch (e) {
            //     if (e.message && e.message.startsWith('timeout ')) {
            //       this.simple = true
            //       proposedBrigades = await this.$refs.executorSelector.getProposedBrigadesSimple()
            //     } else {
            //       throw e
            //     }
            //   }
            // }

            proposedBrigades.forEach((brigade) => {
              brigade.fullName = this.getBrigadeName(brigade)
              brigade.fullNameLowerCase = brigade.fullName.toLowerCase()
            })

            if (reinforcement) {
              this.proposedReinforcementExecutorsAll = proposedBrigades
            } else {
              this.proposedExecutorsAll = proposedBrigades
            }
          } catch (e) {
            this.proposedExecutorsTime = 0
            console.log(e) // Часто возникает, если попап был закрыт раньше, чем были получены данные
            !!abort && abort()
          }
        }

        if (!reinforcement && this.proposedExecutorsAll != null || reinforcement && this.proposedReinforcementExecutorsAll != null) {
          if (!reinforcement && !update && this.proposedExecutorsUpdateFilterFn) {
            // Когда данные подгрузились после первых нажатий на поле
            update = this.proposedExecutorsUpdateFilterFn
            this.proposedExecutorsUpdateFilterFn = null
          }
          if (reinforcement && !update && this.proposedReinforcementExecutorsUpdateFilterFn) {
            // Когда данные подгрузились после первых нажатий на поле
            update = this.proposedReinforcementExecutorsUpdateFilterFn
            this.proposedReinforcementExecutorsUpdateFilterFn = null
          }
          !!update && update(() => {
            let filteredBrigades
            if (val == null && !reinforcement && this.proposedExecutorsUpdateFilterValue != null) {
              // Когда данные подгрузились после первых нажатий на поле
              val = this.proposedExecutorsUpdateFilterValue
              this.proposedExecutorsUpdateFilterValue = null
            }
            if (val == null && reinforcement && this.proposedReinforcementExecutorsUpdateFilterValue != null) {
              // Когда данные подгрузились после первых нажатий на поле
              val = this.proposedReinforcementExecutorsUpdateFilterValue
              this.proposedReinforcementExecutorsUpdateFilterValue = null
            }
            if (val == null || val.length === 0) {
              filteredBrigades = reinforcement ? this.proposedReinforcementExecutorsAll : this.proposedExecutorsAll
            } else {
              val = val.toLowerCase()
              filteredBrigades = reinforcement ? this.proposedReinforcementExecutorsAll.filter(brigade => brigade.fullNameLowerCase.includes(val)) : this.proposedExecutorsAll.filter(brigade => brigade.fullNameLowerCase.includes(val))
            }

            if (!this.simple) {
              filteredBrigades = filteredBrigades.filter(brigade => {
                if (!brigade.alreadyAssigned && !brigade.isChecked) { // !(!this.reinforcement && brigade.isChecked)
                  const score = brigade.conditionsResultsInfo.employees
                  return score == null || score < 5
                }
                return false
              })
            }

            if (reinforcement && (this.request.proposedExecutorObject && this.request.proposedExecutorObject.type === 'brigade' || !!this.request.assignedBrigade)) {
              const brigade = this.request.proposedExecutorObject ? this.request.proposedExecutorObject.executor : this.request.assignedBrigade
              filteredBrigades = filteredBrigades.filter(br => br.id !== brigade.id)
            }

            const proposedExecutors = filteredBrigades.slice(0, Math.min((reinforcement ? this.proposedReinforcementExecutorsAll.length : this.proposedExecutorsAll.length), 5))
              .map(brigade => {
                return reinforcement ? this.getReinforcementBrigadeObjectOption(brigade) : this.getBrigadeObjectOption(brigade)
              })

            if (!this.isContractorDispatcher) {
              proposedExecutors.push({
                value: {},
                label: 'Расширенный выбор...',
                icon: 'mdi-account-search',
                extendedSearch: true
              })
            }
            if (reinforcement) {
              this.proposedReinforcementExecutorsShowInfo = proposedExecutors
            } else {
              this.proposedExecutorsShowInfo = proposedExecutors
            }
          })
        } else if (this.proposedExecutorsTime === 0) {
          // Когда данных нет из-за ошибки
          !!abort && abort()
        } else if (update) {
          // Когда данные еще не подгрузились
          if (reinforcement) {
            this.proposedReinforcementExecutorsUpdateFilterFn = (callback) => {
              update(callback)
            }
            this.proposedReinforcementExecutorsUpdateFilterValue = val
          } else {
            this.proposedExecutorsUpdateFilterFn = (callback) => {
              update(callback)
            }
            this.proposedExecutorsUpdateFilterValue = val
          }
        }
      } else {
        !!abort && abort()
      }
    },
    convertRiAssignedBrigadeFromServer: function (brigade) {
      const convertedBrigade = JSON.parse(JSON.stringify(brigade))

      convertedBrigade.brigadeId = convertedBrigade.id || convertedBrigade.brigadeId
      convertedBrigade.brigadeName = convertedBrigade.name || convertedBrigade.brigadeName

      convertedBrigade.fullName = this.getBrigadeName(convertedBrigade, false)
      convertedBrigade.fullNameLowerCase = convertedBrigade.fullName.toLowerCase()

      if (convertedBrigade.startWorkTime) {
        convertedBrigade.workDateMillis = this.formatDateToTimestamp(manba(new Date(convertedBrigade.startWorkTime)).format('DD-MM-YYYY'))
      }

      convertedBrigade.warnings = []
      if (convertedBrigade.forkliftTruckMatchInfo) {
        convertedBrigade.forkliftTruckMessage = convertedBrigade.forkliftTruckMatchInfo.message

        const matchState = convertedBrigade.forkliftTruckMatchInfo.state
        if (matchState === 'success') {
          convertedBrigade.forkliftTruckColor = 'green'
        } else {
          convertedBrigade.warnings.push(convertedBrigade.forkliftTruckMessage)

          if (matchState == 'warning') {
            convertedBrigade.forkliftTruckColor = 'orange'
          } else {
            convertedBrigade.forkliftTruckColor = 'red'
          }
        }
      }
      return convertedBrigade
    },
    formatDateToTimestamp (value) {
      const match = value.match(/^(\d+)-(\d+)-(\d+)$/)
      const timestamp = new Date(match[3], match[2] - 1, match[1])
      return timestamp.getTime()
    },
    getBrigadeObjectOption: function (brigade) {
      const currentTime = new Date().getTime()
      return {
        value: brigade,
        label: brigade.fullName,
        brigadeName: brigade.brigadeName,
        fullName: brigade.fullName,
        workShiftIcon: this.getWorkShiftIconName(brigade.workShift),
        workShiftName: brigade.workShift ? brigade.workShift.name : null,
        date: brigade.startWorkTime ? manba(new Date(brigade.startWorkTime)).format('DD.MM') : '',
        dateColor: brigade.startWorkTime && brigade.startWorkTime < currentTime ? 'blue' : 'black',
        forkliftTruckMessage: brigade.forkliftTruckMessage,
        forkliftTruckColor: brigade.forkliftTruckColor
      }
    },
    getReinforcementBrigadeObjectOption: function (brigade) {
      const currentTime = new Date().getTime()
      return {
        value: {
          brigadeId: brigade.brigadeId
        },
        brigade: brigade,
        label: brigade.fullName,
        brigadeName: brigade.brigadeName,
        fullName: brigade.fullName,
        workShiftIcon: this.getWorkShiftIconName(brigade.workShift),
        workShiftName: brigade.workShift ? brigade.workShift.name : null,
        date: brigade.startWorkTime ? manba(new Date(brigade.startWorkTime)).format('DD.MM') : '',
        dateColor: brigade.startWorkTime && brigade.startWorkTime < currentTime ? 'blue' : 'black',
        forkliftTruckMessage: brigade.forkliftTruckMessage,
        forkliftTruckColor: brigade.forkliftTruckColor
      }
    },
    onFocusExecutor: function (event) {
      this.showExecutorInput = true
      this.onFocusField(event, this.onClearExecutor)
    },
    onFocusReinforcementExecutor: function (event) {
      this.showReinforcementExecutorsInput = true
      this.onFocusField(event, this.blurReinforcementExecutor)
    },
    onFocusField: function (event, callback) {
      setTimeout(() => {
        const keydownFn = (evt) => {
          evt = evt || window.event
          if (evt.keyCode === 27) { // escape
            callback()
          }
        }
        event.target.addEventListener('keydown', keydownFn)

        event.target.addEventListener('focusout', () => {
          event.target.removeEventListener('keydown', keydownFn)
        }, { once: true })
      }, 1000)
    },
    onClearExecutor: function () {
      const input = this.$refs.executorField.$refs.target
      if (input) {
        input.blur()
      }
    },
    onClearReinforcementExecutor: function () {
      this.blurReinforcementExecutor()
      this.clearReinforcementExecutors()
    },
    blurReinforcementExecutor: function () {
      const input = this.$refs.reinforcementExecutorField.$refs.target
      if (input) {
        input.blur()
      }
    },
    onBlurExecutor: function () {
      this.showExecutorInput = false
    },
    onBlurReinforcementExecutor: function () {
      this.showReinforcementExecutorsInput = false
    },
    onSelectExecutor: function (selection) {
      if (selection && selection.extendedSearch) {
        this.showProposedExecutors()
      } else if (selection) {
        this.request.proposedExecutorObject = {
          type: 'brigade',
          name: selection.value.fullName,
          executor: selection.value
        }
      } else {
        this.request.proposedExecutorObject = null
      }
    },
    onSelectReinforcementExecutor: function (selection) {
      if (!this.ignoreInputChange) {
        if (selection && selection.length && selection.filter(sel => sel.extendedSearch).length > 0) {
          this.showProposedReinforcementExecutors()
        } else if (selection && selection.length) {
          this.request.proposedReinforcementExecutorObject = {
            executors: selection.map(sel => {
              const brigade = JSON.parse(JSON.stringify(sel.brigade))
              brigade.fullName = this.getBrigadeName(brigade, false)
              return brigade
            })
          }
        } else {
          this.request.proposedReinforcementExecutorObject = null
          this.clearReinforcementExecutors()
        }
      }
    },
    onProposedExecutorChange: function (proposedExecutorObject, oldProposedExecutorObject) {
      this.showExecutorInput = false

      if (proposedExecutorObject == null) {
        if (!this.request.hasAssignedExecutor && oldProposedExecutorObject != null) {
          this.request.autoAssign = true
        }
      } else {
        this.request.autoAssign = false
      }
    },
    getWorkShiftIconName: function (workShift) {
      if (workShift) {
        const key = workShift.key ? workShift.key : workShift
        return getWorkShiftIconName(key)
      } else {
        return ''
      }
    },
    onBackspaceKeyDown: function () {
      this.ignoreInputChange = true
      this.$nextTick(() => {
        this.ignoreInputChange = false
      })
    },
    onInputChange: function (value) {
      if (!this.ignoreInputChange) {
        value = value.length ? [value[value.length - 1]] : []
        this.setValue(value)

        // if (value.length) {
        //   this.$nextTick(() => {
        //     this.$refs.select.hidePopup()
        //     this.$nextTick(() => {
        //       this.hideSearchInput()
        //     })
        //   })
        // }
      }
    },
    setValue: function (value) {
      this.$emit('input', value)
    }
  }
}
